module.exports = "/images/ny-life2-7.jpg";